export const SAVE_SELECTION = "SAVE_SELECTION";
